import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import BIcon from './BIcon.vue';
import IconDate from './icons/IconDate.vue';
import IconTime from './icons/IconTime.vue';
import IconEye from './icons/IconEye.vue';
import IconEyeSlash from './icons/IconEyeSlash.vue';
import { emailIsValid, usernameIsValid, usernameOrEmailIsValid, passwordIsValid, organizerNameIsValid, organizerDisplayNameIsValid, linkIsValid, numberIsValid, maxValue as maxValueValidator, minValue as minValueValidator, maxTicketQuantity, isInteger, phoneNumberIsValid } from '~/utils/validation';
export default /*#__PURE__*/_defineComponent({
  __name: 'BInputField',
  props: {
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    leftIcon: {
      type: String,
      default: ''
    },
    rightIcon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    infoText: {
      type: String,
      default: ''
    },
    rightOrientation: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    min: {
      type: Number,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    noValidate: {
      type: Boolean,
      default: false
    },
    counterValue: {
      type: Number,
      default: null
    },
    maxQuantity: {
      type: Boolean,
      default: false
    },
    integer: {
      type: Boolean,
      default: false
    },
    confirmPassword: {
      type: String,
      default: ''
    },
    phoneNumber: {
      type: Boolean,
      default: false
    },
    infoTextClickable: {
      type: Boolean,
      default: false
    },
    rightInfo: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'hasError', 'infoTextClicked', 'enterKeyPressed'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var input = ref();
    var inputType = ref(props.type);
    var focus = ref(false);
    var errorOccurred = ref(false);
    var infoMessage = ref(props.infoText);
    var fieldTypes = ['userEmail', 'username', 'usernameOrEmail', 'organizerName', 'displayName', 'link'];
    var maximumInputLength = ref(props.maxLength);
    var model = computed({
      get: function get() {
        return props.value;
      },
      set: function set(value) {
        return emit('input', value);
      }
    });
    var isFilled = computed(function () {
      var _model$value;
      return model.value !== null && (((_model$value = model.value) === null || _model$value === void 0 ? void 0 : _model$value.length) > 0 || model.value !== '' && !isNaN(Number(model.value)));
    });
    var typePassword = computed(function () {
      return props.rightIcon === 'show';
    });
    var maxValueLimit = computed(function () {
      if (props.max && props.type === 'number') {
        return props.max;
      }
      return null;
    });
    var minValueLimit = computed(function () {
      if (props.min && props.type === 'number') {
        return props.min;
      }
      return null;
    });
    function onPaste(e) {
      emit('input', e.target.value);
      setTimeout(function () {
        validateInput(e.target.value);
      }, 100);
    }
    function onKeyUp(e) {
      emit('input', e.target.value);
      setTimeout(function () {
        validateInput(e.target.value);
      }, 100);
    }
    function onClick() {
      focus.value = true;
      setTimeout(function () {
        input.value.focus();
      }, 100);
    }
    function onInput(e) {
      if (inputType.value !== 'password') {
        return;
      }
      emit('input', e.target.value);
      setTimeout(function () {
        validateInput(e.target.value);
      }, 100);
    }
    function onFocus() {
      focus.value = true;
    }
    function onEnterKey() {
      emit('enterKeyPressed');
    }
    function onFocusOut(e) {
      focus.value = false;
      if (e.relatedTarget) {
        validateInput(e.target.value);
      }
    }
    function onBlur(e) {
      focus.value = false;
      if (e.relatedTarget) {
        validateInput(e.target.value);
      }
    }
    function toggleType(type) {
      inputType.value = type === 'password' ? 'text' : 'password';
    }
    function infoMessageClicked() {
      emit('infoTextClicked');
    }
    function validateInput(eVal) {
      if (props.noValidate) {
        return;
      }
      if (!props.value && !props.required) {
        errorOccurred.value = false;
        infoMessage.value = '';
        return;
      }
      if (props.required && props.value === '') {
        errorOccurred.value = true;
        infoMessage.value = t('validations.required');
        emit('hasError', errorOccurred.value);
        return;
      }
      if (maxValueLimit.value && !maxValueValidator(props.value, maxValueLimit.value)) {
        errorOccurred.value = true;
        infoMessage.value = t('validations.max_value', {
          max: maxValueLimit.value
        });
        emit('hasError', errorOccurred.value);
        return;
      }
      if (minValueLimit.value && !minValueValidator(props.value, minValueLimit.value)) {
        errorOccurred.value = true;
        infoMessage.value = t('validations.min_value', {
          min: minValueLimit.value
        });
        emit('hasError', errorOccurred.value);
        return;
      }
      if (props.maxQuantity && !maxTicketQuantity(props.value)) {
        errorOccurred.value = true;
        infoMessage.value = t('validations.max_quantity');
        emit('hasError', errorOccurred.value);
        return;
      }
      if (props.integer && !isInteger(props.value)) {
        errorOccurred.value = true;
        infoMessage.value = t('validations.integer');
        emit('hasError', errorOccurred.value);
        return;
      }
      if (props.phoneNumber && !phoneNumberIsValid(props.value)) {
        errorOccurred.value = true;
        infoMessage.value = t('validations.phoneNumber');
        emit('hasError', errorOccurred.value);
        return;
      }
      switch (props.type) {
        case 'userEmail':
          errorOccurred.value = !emailIsValid(eVal);
          infoMessage.value = !emailIsValid(eVal) ? t('validations.email') : '';
          break;
        case 'username':
          errorOccurred.value = !usernameIsValid(eVal);
          infoMessage.value = !usernameIsValid(eVal) ? t('validations.username') : '';
          break;
        case 'usernameOrEmail':
          errorOccurred.value = !usernameOrEmailIsValid(eVal);
          infoMessage.value = !usernameOrEmailIsValid(eVal) ? t('validations.emailOrUsername') : '';
          break;
        case 'password':
          errorOccurred.value = !passwordIsValid(eVal);
          infoMessage.value = !passwordIsValid(eVal) ? t('validations.password') : '';
          break;
        case 'confirm_password':
          errorOccurred.value = props.confirmPassword !== eVal;
          infoMessage.value = props.confirmPassword !== eVal ? t('validations.confirm_password') : '';
          break;
        case 'organizerName':
          errorOccurred.value = !organizerNameIsValid(eVal);
          infoMessage.value = !organizerNameIsValid(eVal) ? t('validations.organizer_name') : '';
          break;
        case 'displayName':
          errorOccurred.value = !organizerDisplayNameIsValid(eVal);
          infoMessage.value = !organizerDisplayNameIsValid(eVal) ? t('validations.organizer_display_name') : '';
          break;
        case 'link':
          errorOccurred.value = !linkIsValid(eVal);
          infoMessage.value = !linkIsValid(eVal) ? t('validations.valid_link') : '';
          break;
        case 'number':
          errorOccurred.value = !numberIsValid(eVal);
          infoMessage.value = !numberIsValid(eVal) ? t('validations.valid_number') : '';
          break;
        default:
          errorOccurred.value = false;
          infoMessage.value = '';
          break;
      }
      emit('hasError', errorOccurred.value);
    }
    watch(function () {
      return props.infoText;
    }, function (newValue) {
      infoMessage.value = newValue;
    });
    watch(function () {
      return props.value;
    }, function (newValue) {
      model.value = newValue;
      setTimeout(function () {
        validateInput(newValue);
      }, 100);
    });
    onMounted(function () {
      if (fieldTypes.includes(props.type)) {
        inputType.value = 'text';
      }
      if (props.counterValue) {
        maximumInputLength.value = props.counterValue;
      }
      if (props.type === 'confirm_password') {
        inputType.value = 'password';
      }
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      t: t,
      input: input,
      inputType: inputType,
      focus: focus,
      errorOccurred: errorOccurred,
      infoMessage: infoMessage,
      fieldTypes: fieldTypes,
      maximumInputLength: maximumInputLength,
      model: model,
      isFilled: isFilled,
      typePassword: typePassword,
      maxValueLimit: maxValueLimit,
      minValueLimit: minValueLimit,
      onPaste: onPaste,
      onKeyUp: onKeyUp,
      onClick: onClick,
      onInput: onInput,
      onFocus: onFocus,
      onEnterKey: onEnterKey,
      onFocusOut: onFocusOut,
      onBlur: onBlur,
      toggleType: toggleType,
      infoMessageClicked: infoMessageClicked,
      validateInput: validateInput,
      BIcon: BIcon,
      IconDate: IconDate,
      IconTime: IconTime,
      IconEye: IconEye,
      IconEyeSlash: IconEyeSlash
    };
  }
});